import "./index.scss";
import uuidv4 from "uuid";
import { apiFetch } from "../../../services/api-fetch";
import { triggerEvent } from "../../../services/helpers/trigger-event";
import Toast from "../../../components/modal/toast";

let unique = uuidv4();
document.cookie = `testTemporaryToken=${unique};path=/;`;

let testViewContainer, questionContainer, resultContainer;
let timer;

let passed = 0;

let interrupted = false;

onDomReady.then(() => {
  const url = new URL(window.location.href);
  const focus = url.searchParams.get('focus');

  if (focus) {
    switch (focus) {
      case "comment":
        const textarea = document.querySelector("[name=commentContent]");

        if (textarea) {
          textarea.focus();
        }
      break;
    }
  }
});

const checkAnswers = (action, formData, loadButton) => {
  return new Promise((resolve, reject) => {
    if (loadButton) {
      loadButton.setAttribute('data-loading', '');
      loadButton.disabled = true;
    }
    formData.append("unique", unique);

    apiFetch(action, {
      method: "POST",
      body: formData
    })
    .then(res => {

      if (loadButton) {
        loadButton.removeAttribute('data-loading');
      }

      if (res.success) {
        resolve(res);
        
      } else {
        throw new Error();
      }
    })
    .catch(error => {
      Toast.open("Что-то пошло не так", { state: "error" });
      console.error(error);
      reject();
    });
  })
  
}

const initQuestion = () => { 
  triggerEvent(document.body, "update.lazy");

  let form = questionContainer.querySelector('.test-view-question');
  let isMultiple = form.hasAttribute('data-multiple');
  let checkButton = form.querySelector('[data-check-answer]');
  let nextButton = form.querySelector('[data-next-question]');
  let terminateButton = form.querySelector('[data-terminate]');



  if (highlight) {
    setTimeout(() => {
      highlight.initBlock(form);
    }, 0); 
  }
  
  let variants = Array.from(form.querySelectorAll('[data-test-variant]'))
    .map(variant => {
      return {
        id: variant.value,
        input: variant,
        element: variant.closest('.test-view-variant')
      }
    });

  const blockVariants = () => {
    variants.forEach(variant => variant.input.disabled = true);
  }

  const check = (loadButton) => {
    let data = new FormData(form);
    blockVariants();

    if (interrupted) { 
      return;
    }

    checkAnswers(form.action, data, loadButton)
      .then(res => {
        let checkedVariant;

        variants.forEach(variant => {
          if (variant.input.checked) {
            variant.element.classList.add('checked');
            checkedVariant = variant;
          }

          if (res.correctAnswers.indexOf(variant.id) !== -1) {
            variant.element.classList.add('correct');
          } else {
            variant.element.classList.add('incorrect');
          }
        });

        let explained = false;

        if (res.clarification) {
          res.clarification.forEach(item => {
            item.data = JSON.parse(item.data);

            if (item.data.clarification) {
              explained = true;
              const variant = variants.find(variant => variant.id == item.id);
              const isCorrect = res.correctAnswers.includes(item.id);
              const correctClass = isCorrect ? 'correct' : 'incorrect';
              let heading = '';

              if (checkedVariant.id == item.id && isCorrect) {
                heading = "<h2 class='test-view-explanation__title ma-0'>Верно</h2>";
              }
              else if (checkedVariant.id == item.id) {
                heading = "<h2 class='test-view-explanation__title ma-0'>Неверно</h2>";
              }
              else if (isCorrect) {
                heading = "<h2 class='test-view-explanation__title ma-0'>Правильный вариант</h2>";
              }

              if (variant) {
                const html = `<div class="mv-4 test-view-explanation ${ correctClass }">
                  ${ heading }
                  <div class="test-view-explanation__content mt-4">${ item.data.clarification }</div>
                </div>`;
                
                variant.element.insertAdjacentHTML('beforeEnd', html);
              }
            }
          });
        }

        if (!explained) {
          let variantForExplanation = !isMultiple && checkedVariant ? checkedVariant : variants[variants.length - 1];

          variantForExplanation.element.insertAdjacentHTML('beforeEnd', res.explanation);

          if (highlight) {
            setTimeout(() => {
              highlight.initBlock(variantForExplanation.parentElement);
            }, 0); 
          }
        }

        if (nextButton) nextButton.disabled = false;
        if (terminateButton) {
          if (timer) timer.stop();
          terminateButton.disabled = false;
        }
      });
  }

  document.body.addEventListener("interruptTest", e => {
    blockVariants();
    if (nextButton) nextButton.disabled = true;
    if (terminateButton) terminateButton.disabled = true;
    if (checkButton) checkButton.disabled = true;
  }, { once: true });

  form.addEventListener('change', () => {
    if (isMultiple) {
      if (checkButton) {
        checkButton.disabled = variants.some(variant => variant.checked);
      }
    } else {
      let loadButton = nextButton || terminateButton;
      check(loadButton);
    }
  });

  if (checkButton) {
    checkButton.addEventListener('click', () => {
      checkButton.setAttribute('data-loading', '');
      checkButton.disabled = true;
      check(checkButton);
    });
  }

  if (nextButton) {
    nextButton.addEventListener('click', () => {
      loadQuestion(nextButton.dataset.action, new FormData(), nextButton);
    })
  }

  if (terminateButton) {
    terminateButton.addEventListener('click', () => {
      terminateTest(terminateButton.dataset.action, new FormData(), terminateButton);
    })
  }

}

const initResult = () => {
  triggerEvent(document.body, "update.lazy");
  if (highlight) {
    setTimeout(() => {
      highlight.initBlock(resultContainer);
    }, 0); 
  }
}

const loadQuestion = (action, formData, loadButton) => {
  formData.append("unique", unique);
  formData.append("passed", passed++);
  if (loadButton.dataset.token) {
    formData.append("token", loadButton.dataset.token);
  }

  if (loadButton) {
    loadButton.setAttribute('data-loading', '');
    loadButton.disabled = true;
  }

  return new Promise((resolve, reject) => {
    apiFetch(action, {
      method: "POST",
      body: formData
    })
    .then(res => {

      if (loadButton) {
        loadButton.removeAttribute('data-loading');
        loadButton.disabled = false;
      }
    
      if (res.success) {
        testViewContainer.classList.add('test-in-process');
        questionContainer.innerHTML = res.html;
        initQuestion();
      }
    })
    .catch(error => {
      if (loadButton) {
        loadButton.removeAttribute('data-loading');
        loadButton.disabled = false;
      }
    });
  })
}

const terminateTest = (action, formData, loadButton) => {
  if (timer) timer.stop();

  if (loadButton.dataset.token) {
    formData.append("token", loadButton.dataset.token);
  }

  formData.append("unique", unique);

  if (loadButton) {
    loadButton.setAttribute('data-loading', '');
    loadButton.disabled = true;
  }
  
  return new Promise((resolve, reject) => {
    apiFetch(action, {
      method: "POST",
      body: formData
    })
    .then(res => {
      if (loadButton) {
        loadButton.removeAttribute('data-loading');
        loadButton.disabled = false;
      }

      if (res.success) {
        testViewContainer.classList.remove('test-in-process');
        testViewContainer.classList.add('finished');
        resultContainer.innerHTML = res.html;
        initResult();
      }
    })
    .catch(error => {
      if (loadButton) {
        loadButton.removeAttribute('data-loading');
        loadButton.disabled = false;
      }
    });
  })
}

const interruptTest = (action, config = {}) => {
  interrupted = true;
  triggerEvent(document.body, "interruptTest");

  questionContainer.setAttribute('data-loading', '');

  let formData = new FormData();
  formData.append("unique", unique);

  if (config.token) {
    formData.append("token", config.token);
  }

  apiFetch(action, {
    method: 'POST',
    body: formData
  })
  .then(res => {
    questionContainer.removeAttribute('data-loading');
    if (res.success) {
      testViewContainer.classList.remove('test-in-process');
      testViewContainer.classList.add('finished');
      resultContainer.innerHTML = res.html;
      initResult();
    } else {
      console.error(res.error);
    }
  })
  .catch(error => {
    questionContainer.removeAttribute('data-loading');
    console.error(error);
  });
}

const initTimer = (time, interruptAction, interruptConfig) => {
  let timerElement = testViewContainer.querySelector('.test-view__timer');

  let min, sec;

  time = time * 60; // min -> sec

  if (timerElement) {
    min = timerElement.querySelector('[data-min]');
    sec = timerElement.querySelector('[data-sec]');
  }

  let interval = null;

  const setTime = timeLeft => {
    let m = Math.floor(timeLeft / 60);
    let s = timeLeft - m * 60;

    if (timeLeft < 10) timerElement.classList.add('warning');

    if (min) min.textContent = m < 10 ? `0${m}` : m;
    if (sec) sec.textContent = s < 10 ? `0${s}` : s;
  }

  setTime(time);

  return {
    start: () => {
      interval = setInterval(() => {
        time = time - 1;
        setTime(time);

        if (time <= 0) {
          clearInterval(interval);
          interruptTest(interruptAction, interruptConfig);
        }
      }, 1000);
    },
    stop: () => {
      clearInterval(interval);
    }
  }
}

window.initTestView = (config = {}) => {
  testViewContainer = document.querySelector('.test-view');
  questionContainer = testViewContainer.querySelector('.test-view__question');
  resultContainer = testViewContainer.querySelector('.test-view__result');

  let startForm = document.querySelector('[data-test-start]');

  if (config.time) {
    let time = parseFloat(config.time);
    if (time) {
      timer = initTimer(time, config.interruptAction, config.interruptConfig);
    }
  }
  
  startForm.addEventListener('submit', () => {
    let action = startForm.action;
    let submit = startForm.querySelector('[type="submit"]');
    let data = new FormData(startForm);
    loadQuestion(action, data, submit);

    if (timer) timer.start();
  });
};